import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
    fetchPublicacion,
    editPublicacion,
    fetchTiposPublicacion,
    fetchVariaciones,
    fetchMotivosRevision,
    seModificaronImagenes,
    setImagesUploader,
    updateListPublicaciones,
    resetPublicaciones
} from '../../../../actions/publicacionesActions';
import {
    deletePublicacionApi,
    updatePublicacionApi,
    updatePublicacionEstadoBulkApi,
    updatePublicacionDimensionesBulkApi,
    updatePublicacionPrecioYStockBulkApi,
    updateImagenesApi,
    createImageUrl
} from '../../../../api/axios';
import { setBusquedaGlobalResultados } from '../../../../actions/busquedaGlobalActions';
import { fetchGarantias } from '../../../../actions/garantiasActions';
import { fetchRebate } from '../../../../actions/rebatesActions';
import { getIdEstadoPublicacion, parsePublicacion, switchCardEstado, getEstadoPublicacionFromId } from '../../../../helper/publicacionHelper';
import DatosBasicos from './DatosBasicos';
import PrecioPago from './PrecioPago';
import Entrega from './Entrega';
import Imagenes from './Imagenes';
import Estado from './Estado';
import Garantia from './Garantia'
import Tab from '../../../General/Tab'
import ModalItem from '../../../General/Modal';
import BigSpinner from "../../../General/BigSpinner";
import MiniSpinner from "../../../General/MiniSpinner";
import { toast } from 'react-toastify';
import GoBackArrow from '../../../General/GoBackArrow';


// Wrapper para usar hooks en class component
function PublicacionEditWrapper(props) {
  const navigate = useNavigate();
  const { id, idSeller } = useParams();
  const location = useLocation();
  return <PublicacionEdit {...props} navigate={navigate} id={id} idSeller={idSeller} location={location} />;
}

class PublicacionEdit extends React.Component {
        // Normaliza la publicación para el render de BusquedaGlobalResultados
        normalizePublicacionForBusquedaGlobal = (pub) => {
            // Normalización robusta para mostrar solo texto descriptivo
            const getDescripcion = (obj) => {
                if (!obj || typeof obj !== 'object') return obj ?? "";
                return obj.descripcion ?? obj.nombre ?? "";
            };

            // Dejar estado como string original para que el componente visual lo procese correctamente
            return {
                titulo: pub.titulo,
                skuSeller: pub.skuSeller ?? pub.sellerSku,
                skuMarket: pub.skuMarket,
                categoria: pub.descripcionCategoria ?? getDescripcion(pub.categoria),
                precioLista: pub.precioLista,
                precioPromocional: pub.precioPromocional,
                estado: getEstadoPublicacionFromId(pub.estado),
                imagenes: pub.imagenes ?? (pub.imagen ? [pub.imagen] : []),
                idPublicacion: pub.idPublicacion,
                marca: pub.descripcionMarca ?? getDescripcion(pub.marca),
                tipoEntrega: pub.tipoEntrega,
                fechaPublicacion: pub.fechaPublicacion,
                envioGratis: pub.envioGratis,
                descripcionSeller: pub.descripcionSeller,
                tipoPublicacion: getDescripcion(pub.tipoPublicacion),
                stock: pub.stock,
                exceptuado: pub.exceptuado,
            };
        }
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0,
            showModal: false,
            tabs: [
                { name: "Datos Básicos ", icon: "ti-home", content: <DatosBasicos idSeller={this.props.idSeller} id={this.props.id} isEditing={true} /> },
                { name: "Precio y Medio de Pago", icon: "sl-icon-wallet", content: <PrecioPago id={this.props.id} isEditing={true} /> },
                { name: "Entrega ", icon: "sl-icon-globe", content: <Entrega idSeller={this.props.idSeller} id={this.props.id} /> },
                { name: "Imagenes ", icon: "sl-icon-picture", content: <Imagenes idSeller={this.props.idSeller} id={this.props.id} /> },
                { name: "Estado ", icon: "sl-icon-layers", content: <Estado idSeller={this.props.idSeller} id={this.props.id} inCreate={false} return={this.goToPreviousPath} /> },
                { name: "Garantía ", icon: "ti-home", content: <Garantia idSeller={this.props.idSeller} id={this.props.id} isEditing={true} /> },
            ],
            isClicked: false,
            publicacionPrevia: [],
            dimensionesPrevias: [],
            isLoading: true
        };
    }

   componentDidMount() {
    const { idSellerPub } = this.props.location?.state || {};
    this.props.setImagesUploader([], false);
    this.props.fetchPublicacion(this.props.id, this.props.idSeller);

    // ✅ Solo llamo si realmente tengo un seller (caso Sellers tab, etc.)
    if (idSellerPub) {
        this.props.fetchTiposPublicacion(idSellerPub);
    }

    this.props.fetchMotivosRevision();
}

componentDidUpdate(prevProps) {
    // Si cambia el id de la publicación, mostrar spinner y limpiar datos previos y store
    if (this.props.id !== prevProps.id) {
        this.setState({
            isLoading: true,
            publicacionPrevia: [],
            dimensionesPrevias: []
        });
        if (this.props.resetPublicaciones) {
            this.props.resetPublicaciones();
        }
    }

    // ✅ NUEVO: cuando ya tengo la publicación con idSeller y aún no tengo tipos, los pido
    const sellerActual = this.props.publicacion?.idSeller;
    const sellerPrevio = prevProps.publicacion?.idSeller;

    if (
        sellerActual &&                                  // hay seller
        sellerActual !== sellerPrevio &&                 // cambió respecto al render anterior
        (!Array.isArray(this.props.tiposPublicacion) ||  // y no tengo tipos cargados
         this.props.tiposPublicacion.length === 0)
    ) {
        this.props.fetchTiposPublicacion(sellerActual);
    }

    // Cuando llegan los datos nuevos, ocultar el spinner
    if (this.props.publicacion.idPublicacion !== this.state.publicacionPrevia?.idPublicacion) {
        const dims = this.props.publicacion?.dimensiones ?? [];
        this.setState({
            publicacionPrevia: this.props.publicacion,
            dimensionesPrevias: JSON.parse(JSON.stringify(dims)),
            isLoading: false
        });
    }

    if (
        !prevProps.publicacion?.tieneRebate &&
        this.props.publicacion?.tieneRebate
    ) {
        this.props.fetchRebate(this.props.id);
    }
}

    onSubmit = async (event) => {
        event.preventDefault();
        this.setState({ isClicked: true });

        let publicacion = { ...this.props.publicacion };
        publicacion.userId = this.props.userId;

        const tipoValido = this.props.tiposPublicacion.some(
            tipo => tipo.codigo?.toString() === publicacion.idTipoPublicacion?.toString()
        );

        if (!tipoValido) {
            toast.error("No existe este tipo de publicación, seleccione otro antes de seguir");
            this.setState({ isClicked: false });
            return;
        }

        if (this.props.userType.isAdminMod || this.props.userType.isCategory) {
            publicacion.estado = this.props.publicacion.estado;
        }

        publicacion = parsePublicacion(publicacion);
        let publicacionInicial = parsePublicacion(this.state.publicacionPrevia);

        if (publicacion.precioPromocional >= publicacion.precioLista) {
            toast.error("El precio promocional no puede ser igual o mayor al precio de lista");
            this.setState({ isClicked: false });
            return;
        }

        const zonasKeys = ['amba', 'interior', 'patagonia'];
        const zonasEnvioGratisChanged = zonasKeys.some(key =>
            publicacion.zonasEnvioGratis?.[key] !== publicacionInicial.zonasEnvioGratis?.[key]
        );


        const verifyMasiva = [
            "observacion", "titulo", "ean", "linkYoutube",
            "descripcionAmpliada", "envioGratis", "categoria", "marca",
            "idTipoPublicacion", "idMotivoRevision", "observacionesRevision",
            "skuSeller", "envioPropio", "codigoLegibilidad",
            "garantiaExtActiva", "garantiaFabrica"
        ];

        const canEditMasiva = verifyMasiva.some(item => publicacion[item] !== publicacionInicial[item]) || zonasEnvioGratisChanged;

        if (canEditMasiva) {
            await this.updatePublicacionMasiva(publicacion);
        }

        const verifyPrecio = ["precioLista", "precioPromocional", "stock", "alicuotaIva", "alicuotaImpuestoInterno"];
        const canEditPrecio = verifyPrecio.some(item => publicacion[item] !== publicacionInicial[item]);

        let cambioEstadoPorStock = false;

        // Si el stock cambió a 0, la publicación se pausa automáticamente
        if (publicacion.stock === 0 && publicacion.stock !== publicacionInicial.stock) {
            publicacion.estado = "pausado";
            cambioEstadoPorStock = true;
        }
        // Si el stock cambió y ahora es mayor a 0, la publicación se activa automáticamente
        else if (publicacion.stock > 0 && publicacionInicial.stock === 0) {
            publicacion.estado = "activo";
            cambioEstadoPorStock = true;
        }

        if (canEditPrecio) {
            await this.updatePrecioYStock(publicacion);
        }

        const verifyDimensiones = ["alto", "ancho", "peso", "profundidad"];
        let canEditDimensiones = false;
        if (publicacion.dimensiones.length === this.state.dimensionesPrevias.length) {
            for (let i = 0; i < publicacion.dimensiones.length; i++) {
                canEditDimensiones = verifyDimensiones.some(item => publicacion.dimensiones[i][item] !== this.state.dimensionesPrevias[i][item]);
                if (canEditDimensiones) break;
            }
        } else {
            canEditDimensiones = true;
        }
        if (canEditDimensiones) {
            await this.updateDimensiones(publicacion);
        }

        //const verifyEstado = ["estado"];
        //const canEditEstado = verifyEstado.some(item => publicacion[item] !== publicacionInicial[item] || cambioEstadoPorStock);
        //if (canEditEstado) {
        //    await this.updateEstado(publicacion);
        //}

        await this.updateImagenes(publicacion);

        this.props.updateListPublicaciones(this.props.publicaciones, publicacion);

        // Si viene de BusquedaGlobalResultados, actualiza también el estado global
        if (this.props.location?.state?.pathReturn === '/BusquedaGlobalResultados') {
            // Actualiza la publicación en el reducer de búsqueda global, conservando datos originales
            if (this.props.busquedaGlobalResultados) {
                const nuevasPublicaciones = this.props.busquedaGlobalResultados.publicaciones.map(pub => {
                    if (pub.idPublicacion === publicacion.idPublicacion) {
                        // Mezcla los datos: si el edit no trae el campo, usa el original
                        const merged = {
                            ...pub,
                            ...publicacion,
                            categoria: publicacion.categoria ?? pub.categoria,
                            marca: publicacion.marca ?? pub.marca,
                            tipoEntrega: publicacion.tipoEntrega ?? pub.tipoEntrega,
                            estado: typeof publicacion.estado === 'number' ? publicacion.estado : pub.estado
                        };
                        return this.normalizePublicacionForBusquedaGlobal(merged);
                    }
                    return this.normalizePublicacionForBusquedaGlobal(pub);
                });
                const nuevosResultados = {
                    ...this.props.busquedaGlobalResultados,
                    publicaciones: nuevasPublicaciones
                };
                if (this.props.setBusquedaGlobalResultados) {
                    this.props.setBusquedaGlobalResultados(nuevosResultados);
                }
            }
        }

        this.setState({ isClicked: false });
        this.goToPreviousPath();
    };

    updatePublicacionMasiva = async (publicacion) => {
        let newPublicacionMasiva = {
            actualizacionMasivaBulk: [{
                idPublicacion: publicacion.idPublicacion,
                observacion: publicacion.observacion,
                titulo: publicacion.titulo,
                ean: publicacion.ean,
                linkYoutube: publicacion.linkYoutube,
                descripcionAmpliada: publicacion.descripcionAmpliada,
                tipoEntrega: publicacion.tipoEntrega[0],
                envioGratis: publicacion.envioGratis,
                categoria: publicacion.categoria,
                marca: publicacion.marca,
                idTipoPublicacion: publicacion.idTipoPublicacion,
                idMotivoRevision: publicacion.idMotivoRevision,
                observacionesRevision: publicacion.observacionesRevision == null ? "" : publicacion.observacionesRevision,
                skuSeller: publicacion.skuSeller,
                envioPropio: publicacion.envioPropio,
                codigoLegibilidad: publicacion.codigoLegibilidad,
                garantiaExtActiva: publicacion.garantiaExtActiva,
                garantiaFabrica: publicacion.garantiaFabrica,
                envioGratisZona: {
                    amba: publicacion.zonasEnvioGratis?.amba || false,
                    interior: publicacion.zonasEnvioGratis?.interior || false,
                    patagonia: publicacion.zonasEnvioGratis?.patagonia || false
                }

            }],
            idUser: publicacion.userId
        };

        try {
            await updatePublicacionApi(newPublicacionMasiva);
            toast.success("Publicación Editada");
        } catch (err) {
            if (err.response?.data?.errores) {
                err.response.data.errores.forEach(error => toast.error(error));
            } else {
                toast.error("No pudo editarse la Publicación");
            }
        }
    };

    updateDimensiones = async (publicacion) => {
        let newDimensiones = {
            actualizarDimensiones: [{
                idPublicacion: publicacion.idPublicacion,
                dimensiones: publicacion.dimensiones
            }],
            idUser: publicacion.userId
        };

        try {
            await updatePublicacionDimensionesBulkApi(newDimensiones);
            toast.success("Dimensiones actualizadas");
        } catch (err) {
            if (err.response?.data?.errores) {
                err.response.data.errores.forEach(error => toast.error(error));
            } else {
                toast.error("No se pudo editar las dimensiones");
            }
        }
    };

    updatePrecioYStock = async (publicacion) => {
        const payload = {
            idUser: this.props.userId,
            actualizarPrecioYStockBulks: [{
                idPublicacion: publicacion.idPublicacion,
                precioLista: publicacion.precioLista,
                precioPromocional: publicacion.precioPromocional,
                stock: publicacion.stock,
                alicuotaIva: parseFloat(publicacion.alicuotaIva),
                alicuotaImpuestoInterno: publicacion.alicuotaImpuestoInterno,
            }]
        };

        try {
            await updatePublicacionPrecioYStockBulkApi(payload);
            toast.success("Los cambios en el precio, stock o alícuotas se guardaron correctamente.");
        } catch (err) {
            if (err.response?.data?.errores) {
                err.response.data.errores.forEach(error => toast.error(error));
            } else {
                toast.error("No se pudo editar precio y stock");
            }
        }
    };

    updateEstado = async (publicacion) => {
        const idEstado = getIdEstadoPublicacion(publicacion.estado);

        const payload = {
            cambiarEstadoPublicacionesBulks: [{
                idPublicaciones: publicacion.idPublicacion,
                estados: idEstado
            }],
            idUser: this.props.userId
        };

        try {
            await updatePublicacionEstadoBulkApi(payload);
            toast.success("Estado editado");
        } catch (err) {
            if (err.response?.data?.errores) {
                err.response.data.errores.forEach(error => toast.error(error));
            } else {
                toast.error("No se pudo editar el estado");
            }
        }
    };

    //updateImagenes = async (event) => {
    updateImagenes = async (publicacion) => {

        if (!this.props.imagesUploader || !this.props.hayCambiosEnImagenes) {
            return;
        }

        // Copia del estado para trabajar sin mutarlo directamente
        //const updatedImages = this.props.imagesUploader.map(image => ({ ...image }));
        const updatedImages = [...this.props.imagesUploader];

        try {
            // Array de promesas para crear URLs de cada imagen
            const urlRequests = updatedImages.map(async (img, index) => {
                if (img.imagen !== undefined) {

                    const res = await createImageUrl(img.imagen);
                    if (res !== "") {
                        // Asigna el URL devuelto a la imagen
                        updatedImages[index] = {
                            ...img,
                            urlImagen: res.url
                        };
                    } else {
                        toast.error("Error en la URL de la imagen");
                    }
                }
            });

            // Espera a que todas las URLs se hayan generado
            await Promise.all(urlRequests);

            // Crea el payload para la API
            const imagenesBulk = updatedImages.map(img => ({
                // como la primer posicion es cero y la api no permite posición cero, 
                // le sumo 1 a la posicion para que la primer posición sea 1.
                posicion: img.posicion + 1,
                urlImagen: img.urlImagen
            }));

            const updateImagenesRequest = {
                idUser: this.props.userId,
                actualizarImagenesBulks: [
                    {
                        idPublicacion: publicacion.idPublicacion,
                        imagenes: imagenesBulk
                    }
                ]
            };

            // Llamada a la API
            const res = await updateImagenesApi(updateImagenesRequest);
            toast.success("Imágenes editadas");

        } catch (err) {
            if (err.response && err.response.data.errores) {
                err.response.data.errores.forEach(error => toast.error(error));
            } else {
                toast.error("No pudo editarse");
            }
        }
    };

    onDelete = (event) => {
        if (event != null) event.preventDefault();
        this.setState({ isClicked: true })

        const req = deletePublicacionApi(this.props.publicacion.idPublicacion);
        req.then(res => {
            toast.success("Publicación eliminada");
            this.goToPreviousPath();
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo eliminarse");
        }).finally(() => {
            this.setState({ isClicked: false })
        });
    }

    redirectToSeller() {
        localStorage.removeItem("pagina");
        this.props.navigate(`/Sellers/Editar/${this.props.publicacion.idSeller}`);
    }

    selectTipoPublicacion = (idTipoDefault) => {
        let publicacion = this.props.publicacion;
        if (this.props.tiposPublicacion != undefined) {
            this.props.tiposPublicacion.map((item) => {
                if (item.codigo == this.props.publicacion.idTipoPublicacion) {
                    publicacion["idTipoPublicacion"] = item.codigo;
                    return;
                }
            });

            let res = this.props.tiposPublicacion.find(tipo => tipo.codigo === this.props.publicacion.idTipoPublicacion);
            if (res == undefined) {
                publicacion["idTipoPublicacion"] = idTipoDefault;
            }
        }
    }

    goToPreviousPath = () => {
        const { pathReturn } = this.props.location.state;
        this.props.navigate(`${pathReturn}`);
    }

    handleCancel = () => {
        const { publicacion } = this.props;

        // Crea una copia de la publicación actual y resetea solo el campo EAN
        const updatedPublicacion = {
            ...publicacion,
            ean: "",
        };

        this.goToPreviousPath();
    };

    render() {
        const { publicacion, tiposPublicacion } = this.props;
        const { isCategory, isAdminMod } = this.props.userType;
        const { tabs, activeTab, isClicked, showModal } = this.state;
        const externalLoading = this.props.loadingPublicaciones;

        return (
            <div className="container">
                <div className="row align-items-center">
                    {(this.state.isLoading || externalLoading) ? <BigSpinner /> :
                        <div className="card">
                            <div className="col-12 mt-4">
                                <GoBackArrow />
                                <h4 className="card-title d-block d-sm-inline">Editar Publicacion - {publicacion?.idPublicacion}</h4>
                                {(isCategory || isAdminMod) &&
                                    <button className="btn btn-link card-subtitle" onClick={() => { this.redirectToSeller() }}>
                                        {publicacion.nombreSeller}
                                    </button>
                                }
                                <ul className="nav nav-tabs customtab" role="tablist">
                                    {tabs.map((tab, index) => {
                                        if (tab.name != undefined) {
                                            return <div key={index} onClick={() => { this.setState({ activeTab: index }) }}>
                                                <Tab
                                                    name={tab.name}
                                                    icon={tab.icon}
                                                    isActive={index === activeTab}
                                                />
                                            </div>
                                        }
                                    })}
                                </ul>
                                <form className="form-horizontal form-material p-10">
                                    <div className="tab-content">
                                        {tabs[activeTab].content}
                                        <div className="row align-items-center justify-content-center mb-3 text-center">
                                            <div className="col-12 col-sm-auto" hidden={!isClicked}>
                                                <MiniSpinner />
                                            </div>
                                            <button
                                                type="submit"
                                                onClick={(e) => this.onSubmit(e)}
                                                disabled={isClicked}
                                                className="btn btn-sm background-rojo-megatone waves-light col-auto mx-2"
                                            >
                                                Guardar
                                            </button>
                                            <ModalItem
                                                btnText="Eliminar"
                                                text="¿Desea eliminar esta publicación?"
                                                onDelete={this.onDelete}
                                                show={showModal}
                                                disabled={isClicked}
                                                btnStyle="btn btn-sm btn-grey col-auto mx-2"
                                            />
                                            <button
                                                onClick={this.handleCancel}
                                                className="btn btn-sm btn-light waves-effect waves-light col-auto mx-2"
                                            >
                                                Cancelar
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    seller: state.sellers.seller,
    userType: state.general.userType,
    publicacion: state.publicaciones.publicacion,
    tiposPublicacion: state.publicaciones.tiposPublicacion,
    userId: state.general.userId,
    imagesUploader: state.publicaciones.imagesUploader,
    hayCambiosEnImagenes: state.publicaciones.hayCambiosEnImagenes,
    publicaciones: state.publicaciones.publicaciones,
    busquedaGlobalResultados: state.busquedaGlobal.resultados,
    // Use centralized loading flag from publicaciones reducer
    loadingPublicaciones: state.publicaciones.loadingPublicaciones,
});



export default connect(mapStateToProps, {
    fetchPublicacion,
    fetchGarantias,
    editPublicacion,
    fetchTiposPublicacion,
    fetchVariaciones,
    fetchMotivosRevision,
    seModificaronImagenes,
    fetchRebate,
    setImagesUploader,
    updateListPublicaciones,
    resetPublicaciones,
    setBusquedaGlobalResultados
})(PublicacionEditWrapper);
